import { Box, Typography } from "@mui/material";
import { Area, AreaChart, CartesianGrid, Tooltip, XAxis, YAxis } from "recharts";
import theme from "../../App/Styles/theme";
import { DiagonalXAxisTick } from "../Components/DiagonalXAxisTick";
import ReportContainer from "../Components/ReportContainer";
import { getThemedColorCode } from "../Helpers/ThemedColorCodes";
import { ICandidatesAddedReportState } from "./State/CandidatesAddedReportState";

const CustomToolTip = (props: any) => {
  const { active, payload } = props;

  if (active && payload?.length) {
    return (
      <Box
        sx={{
          width: 250,
          margin: 0,
          lineHeight: "24px",
          backgroundColor: "#fff",
          border: "1px solid #000",
          padding: "10px",
        }}
      >
        <Box sx={{ paddingBottom: 2 }}>
          <Typography data-test={payload[0].payload.dateAdded} fontWeight={700}>
            {payload[0].payload.dateAdded}
          </Typography>
        </Box>
        <Box data-test={`candidate-added-count-${payload[0].payload.dateAdded}`}>
          Candidates: {payload[0].value}
        </Box>
      </Box>
    );
  }

  return null;
};

export const CandidatesAddedReport = ({ state }: { state: ICandidatesAddedReportState }) => {
  const { isLoading, reportData } = state;

  return (
    <ReportContainer title="Candidate Captures Per Day" id="candidates-added" isLoading={isLoading}>
      <AreaChart
        data={reportData}
        style={{
          position: "relative",
        }}
        margin={{
          top: 0,
          right: 30,
          left: 20,
          bottom: 60,
        }}
      >
        <defs>
          <linearGradient id="area-gradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={theme.palette.primary.main} stopOpacity={0.3} />
            <stop offset="95%" stopColor={theme.palette.primary.main} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke="#eeeded" vertical={false} />
        <XAxis
          axisLine={false}
          tickLine={false}
          dataKey="dateAdded"
          tick={<DiagonalXAxisTick />}
          tickFormatter={(value: any) => new Date(value).toLocaleDateString()}
        />
        <YAxis axisLine={false} tickLine={false} type="number" domain={["auto", "dataMax"]} />
        <Tooltip
          content={<CustomToolTip />}
          cursor={{ stroke: theme.palette.primary.main, strokeDasharray: 5 }}
        />
        <Area
          type="monotone"
          key="dateAdded"
          dataKey="candidateCount"
          stroke={getThemedColorCode(0)}
          strokeWidth={3}
          fillOpacity={1}
          fill="url(#area-gradient)"
          activeDot={{ r: 6 }}
        />
      </AreaChart>
    </ReportContainer>
  );
};
